import { nanoid } from 'nanoid/async'

import { ecommerceModal } from './ecommerceModal'
import { updateNodeConnections } from '../../utils/functions'


// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: ecommerceData } = await ecommerceModal(oldData, node)

  if (ecommerceData && Object.values(ecommerceData).length > 0) {

    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, ecommerceData)
    node.update()
    updateNodeConnections(node)
  }


  return false
}